/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState, useEffect } from "react";

import { Row, Col, Form, Button, Table } from "react-bootstrap";

import { MM } from "../../engine/model_manager";
import { Categories } from "../../engine/categories";
import DateEditor from "../../components/DateEditor";
import frequency from "../../engine/frequency";


export default function EditItemPane(props) {
  const [active, setActive] = useState(props.modelItem.active);
  const [desc, setDesc] = useState(props.modelItem.desc);
  const [category, setCategory] = useState(props.modelItem.category);
  const [amount, setAmount] = useState(props.modelItem.amount);
  //const [subType, setSubType] = useState(props.modelItem.subType);
  const [freq, setFreq] = useState(props.modelItem.freq);
  const [fromAcct, setFromAcct] = useState(props.modelItem.srcActID);
  const [toAcct, settoAcct] = useState(props.modelItem.dstActID);
  const [start, setStart] = useState(props.modelItem.startExpr);
  const [stop, setStop] = useState(props.modelItem.stopExpr);
  const [validated, setValidated] = useState(false); //???

  const item_type = MM.getItemTypeAsConst(props.modelItem.itemType);


  function onActiveChanged(event) {
    console.log('Active box1='+event.target.checked.toString()+' : Property='+active.toString());
    setActive(!active);
    console.log('Active box2='+event.target.checked.toString()+' : Property='+active.toString());
  }

  function onDescChanged(event) {
    event.preventDefault();

    setDesc(event.target.value);
  }

  function onCategoryChanged(event) {
    event.preventDefault();

    setCategory(event.target.value);
  }

  function onAmountChanged(event) {
    event.preventDefault();

    setAmount(event.target.value); // TODO validate/regex ?
  }

  function onFreqChanged(event) {
    event.preventDefault();

    setFreq(event.target.value);
  }

  function onFromAcctChanged(event) {
    event.preventDefault();

    let id = parseInt(event.target.value);
    setFromAcct(id);
  }

  function onToAcctChanged(event) {
    event.preventDefault();

    let id = parseInt(event.target.value);
    setToAcct(id);
  }

  function onUpdateStart(expr) {
    setStart(expr);
  }

  function onUpdateStop(expr) {
    setStop(expr);
  }


  function onSubmit(event) {
    event.preventDefault();

    let obj = {
      active,
      desc,
      category,
      amount,
      freq,

      srcActID: fromAcct,
      dstActID: toAcct,

      startExpr: start,
      stopExpr: stop
    };

    let action = {
      type: props.itemAction, //'updateItem',
      item: { ...props.modelItem, ...obj }
    }

    props.onSubmit(action);
  }

  function onCancel(event) {
    event.preventDefault();

    props.onCancel();
  }


  console.log(' : Property='+active.toString());
  
  return (
    <>
      <Form noValidate validated={validated} onSubmit={onSubmit}>

        <Form.Group controlId="active">
          <Row>
            <Col xs={3}>
              <Form.Check id="activeflag" type="checkbox" label="Active" checked={active} onChange={onActiveChanged} />
            </Col>
          </Row>
        </Form.Group>

        <Form.Group controlId="desc">
          <Row>
            <Col xs={3}>
              <Form.Label >Description</Form.Label>
            </Col>
            <Col xs={5} sm={3}>
              <Form.Control type="text" required value={desc} onChange={onDescChanged} />
            </Col>
          </Row>
        </Form.Group>

        
        {item_type === MM.ITEMTYPE_EXPENSE &&
        <Form.Group controlId="toAcct">
          <Row>
            <Col xs={3}>
              <Form.Label>Category</Form.Label>
            </Col>
            <Col xs={5} sm={3}>
              <Form.Select defaultValue={category} onChange={onCategoryChanged}>
                {Categories.getExpenseCategories().map(c => <option value={c.longCode}>{c.desc}</option>)}
              </Form.Select>
            </Col>
          </Row>
        </Form.Group>
        }

        <Form.Group controlId="amt">
          <Row>
            <Col xs={3}>
              <Form.Label>Amount</Form.Label>
            </Col>
            <Col xs={5} sm={3}>
              <Form.Control type="text" required value={amount} onChange={onAmountChanged} />
            </Col>
          </Row>
        </Form.Group>

        <Form.Group controlId="freq">
          <Row>
            <Col xs={3}>
              <Form.Label>Frequency</Form.Label>
            </Col>
            <Col xs={5} sm={3}>
              <Form.Select defaultValue={freq} onChange={onFreqChanged}>
                {frequency.getFrequencies().map(f => <option value={f.longCode}>{f.desc}</option>)}
              </Form.Select>
            </Col>
          </Row>
        </Form.Group>

        <Form.Group controlId="fromAcct">
          <Row>
            <Col xs={3}>
              <Form.Label>Account</Form.Label>
            </Col>
            <Col xs={5} sm={3}>
              <Form.Select defaultValue={fromAcct} onChange={onFromAcctChanged}>
                {props.simModel.accts.map(a => <option value={a.baseID}>{a.baseDesc}</option>)}
              </Form.Select>
            </Col>
          </Row>
        </Form.Group>

        {item_type === MM.ITEMTYPE_TRANSFER &&
        <Form.Group controlId="toAcct">
          <Row>
            <Col xs={3}>
              <Form.Label>To Account</Form.Label>
            </Col>
            <Col xs={5} sm={3}>
              <Form.Select defaultValue={toAcct} onChange={onToAcctChanged}>
                {props.simModel.accts.map(a => <option value={a.baseID}>{a.baseDesc}</option>)}
              </Form.Select>
            </Col>
          </Row>
        </Form.Group>
        }


        <Form.Group controlId="start">
          <Row>
            <Col xs={3}>
              <Form.Label>Start</Form.Label>
            </Col>
            <Col xs={9} sm={6}>
              <DateEditor simModel={props.simModel} expr={start} onChange={onUpdateStart} />
            </Col>
          </Row>
        </Form.Group>

        <Form.Group controlId="stop">
          <Row>
            <Col xs={3}>
              <Form.Label>Stop</Form.Label>
            </Col>
            <Col xs={9} sm={6}>
              <DateEditor simModel={props.simModel} expr={stop} onChange={onUpdateStop} />
            </Col>
          </Row>
        </Form.Group>


        <Button variant="primary" type="submit" >Update</Button>
        <Button variant="secondary" type="button" onClick={onCancel}>Cancel</Button>

      </Form>

    </>
  );
}

